import classNames from 'classnames';
import React from 'react';
import { IconSpinner } from './QuirkIcons';
import styles from './QuirkLoading.module.css';

interface QuirkLoadingProps {
	message?: string;
	isLoading: boolean;
}

export const QuirkLoading: React.FC<QuirkLoadingProps> = ({ message = 'Loading...', isLoading }) => {
	const preventClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
	};

	return isLoading ? (
		<div
			className={classNames(styles.loadingContainer, isLoading ? styles.loadingContainerActive : '')}
			onClick={preventClick}
		>
			<div className={classNames(styles.loadingPanel, isLoading ? styles.loadingPanelActive : '')}>
				<div className={styles.spinner}>
					<IconSpinner />
				</div>
				<div className={styles.loadingPanelMessage}>{message}</div>
			</div>
		</div>
	) : null;
};
